import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
const CheckCircleSolid = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M7.22266 0C11.2112 0.000234499 14.4443 3.23408 14.4443 7.22266C14.444 11.211 11.211 14.4441 7.22266 14.4443C3.23431 14.4441 0.00030045 11.211 0 7.22266C0 3.23408 3.23413 0.000230929 7.22266 0ZM10.2529 5.19141C9.96005 4.89853 9.48528 4.89857 9.19238 5.19141L6.38867 7.99414L5.25293 6.8584C4.96005 6.56553 4.48528 6.56556 4.19238 6.8584C3.89968 7.15131 3.89956 7.62611 4.19238 7.91895L5.85938 9.58496C6.15227 9.87774 6.62706 9.87779 6.91992 9.58496L10.2529 6.25195C10.5457 5.95909 10.5457 5.48429 10.2529 5.19141Z" fill="currentColor" transform="translate(2.77734 2.77734)" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default CheckCircleSolid;